// extracted by mini-css-extract-plugin
export default {"headline":"language-change_headline__baFtC","radio":"language-change_radio__ATYVr","reset":"language-change_reset__GyNkk","submit":"language-change_submit__xjn1C"};